import { fetchBusinessCategories } from "../ProfileSettingsPage/ProfileSettingsPage.duck";

export const loadData = (params, search) => dispatch => {
  return Promise.all([
    dispatch(fetchBusinessCategories())
  ]);
};
